import { useSyncExternalStore } from 'react';

import { readEscrowStash } from 'src/utils/escrowCreation';

const subscribe = (onChange: () => void): (() => void) => {
  window.addEventListener('storage', onChange);

  return () => window.removeEventListener('storage', onChange);
};

/**
 * The creation transaction this browser sent for a deal and has not yet seen reported (api#380,
 * `escrow-create-tx:<dealId>` in `localStorage`), or `null` — always `null` once the deal carries
 * its contract address, whatever the browser still remembers.
 *
 * Read as an external store rather than copied into state by an effect: `localStorage` is the
 * browser's alone, so the server's render and the browser's first render both answer `null`, and
 * every later render reads the stash as it is — the payment flow writes and clears it between
 * renders, and the dialog follows without a setter of its own. Another tab's write arrives by the
 * `storage` event.
 */
export const useEscrowStash = (dealId: string, contractAddress: string | null | undefined): string | null =>
  useSyncExternalStore(
    subscribe,
    () => (contractAddress ? null : readEscrowStash(dealId)),
    () => null
  );
